import React, { useState } from 'react';

const MathFunctions = () => {
  const [functionType, setFunctionType] = useState('');
  const [xValue, setXValue] = useState('');
  const [derivativeResult, setDerivativeResult] = useState(null);
  const [integralResult, setIntegralResult] = useState(null);
  const [error, setError] = useState('');

  // Derivatives of standard functions
  const calculateDerivative = (func, x) => {
    let result = null;
    if (func === 'x^n') {
      result = `n * x^(n-1)`;  // For x^n, derivative is n*x^(n-1)
    } else if (func === 'e^x') {
      result = 'e^x'; // Derivative of e^x is e^x
    } else if (func === 'ln(x)') {
      result = '1/x'; // Derivative of ln(x) is 1/x
    } else if (func === 'sin(x)') {
      result = `cos(x)`; // Derivative of sin(x) is cos(x)
    } else if (func === 'cos(x)') {
      result = `-sin(x)`; // Derivative of cos(x) is -sin(x)
    }
    return result;
  };

  // Integrals of standard functions
  const calculateIntegral = (func, x) => {
    let result = null;
    if (func === 'x^n') {
      result = `x^(n+1)/(n+1)`; // Integral of x^n is x^(n+1)/(n+1)
    } else if (func === 'e^x') {
      result = 'e^x'; // Integral of e^x is e^x
    } else if (func === 'ln(x)') {
      result = `x*ln(x) - x`; // Integral of ln(x) is x*ln(x) - x
    } else if (func === 'sin(x)') {
      result = `-cos(x)`; // Integral of sin(x) is -cos(x)
    } else if (func === 'cos(x)') {
      result = `sin(x)`; // Integral of cos(x) is sin(x)
    }
    return result;
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'functionType') {
      setFunctionType(value);
    } else if (name === 'xValue') {
      setXValue(value);
    }
  };

  // Handle calculation when the button is clicked
  const handleCalculate = () => {
    const x = parseFloat(xValue);
    if (isNaN(x) || functionType === '') {
      setError('Please enter a valid function and value for x.');
      return;
    }

    setError('');
    const derivative = calculateDerivative(functionType, x);
    const integral = calculateIntegral(functionType, x);

    setDerivativeResult(derivative);
    setIntegralResult(integral);
  };

  return (
    <div>
      <h2>Derivatives and Integrals of Standard Functions</h2>

      <div>
        <label>Select Function: </label>
        <select
          name="functionType"
          value={functionType}
          onChange={handleInputChange}
        >
          <option value="">--Select--</option>
          <option value="x^n">x^n</option>
          <option value="e^x">e^x</option>
          <option value="ln(x)">ln(x)</option>
          <option value="sin(x)">sin(x)</option>
          <option value="cos(x)">cos(x)</option>
        </select>
      </div>

      <div>
        <label>Enter x value: </label>
        <input
          type="number"
          name="xValue"
          value={xValue}
          onChange={handleInputChange}
        />
      </div>

      <div>
        <button onClick={handleCalculate}>Calculate Derivative and Integral</button>
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {derivativeResult && (
        <div>
          <p><strong>Derivative: </strong>{derivativeResult}</p>
        </div>
      )}

      {integralResult && (
        <div>
          <p><strong>Integral: </strong>{integralResult}</p>
        </div>
      )}
    </div>
  );
};

export default MathFunctions;
